<svg class="rpci" [ngClass]="'rpci-' + iconName">
    <use attr.xlink:href="#new-rpci-{{iconName}}"></use>
</svg>